<div class="dataset-detail">
  <app-header [forceLightBackground]="true"></app-header>
  
  <div class="dataset-detail--content">
    <app-asset-header 
      [config]="headerConfig"
      [isLoggedIn]="isLoggedIn"
      [isBookmarked]="isBookmarked"
      [isLiked]="isLiked"
      [showActions]="true"
      (bookmarkClick)="onBookmarkClick()"
      (likeClick)="onLikeClick()"
    ></app-asset-header>
    
    <!-- Main Content: Two Column Layout -->
    <div class="dataset-detail--main-section">
      <div class="dataset-detail--container">
        <!-- Tabs Navigation - Full Width -->
        <div class="dataset-detail--tabs-wrapper" id="dataset-detail-tabs">
          <div class="dataset-detail--tabs">
              <button 
                class="dataset-detail--tab"
                [class.active]="activeTab === 'dataset'"
                (click)="setActiveTab('dataset')"
                type="button"
              >
                Dataset
              </button>
              <button 
                class="dataset-detail--tab"
                [class.active]="activeTab === 'details'"
                [class.disabled]="shouldDisableRsActionsUntilAccessOk"
                [disabled]="shouldDisableRsActionsUntilAccessOk"
                [attr.title]="shouldDisableRsActionsUntilAccessOk ? 'No Access yet' : null"
                (click)="setActiveTab('details')"
                type="button"
              >
              <svg *ngIf="!isLoggedIn" class="dataset-detail--tab-lock-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Details
              </button>
              <!--
              <button
                class="dataset-detail--tab"
                [class.active]="activeTab === 'visualisation'"
                [class.disabled]="shouldDisableRsActionsUntilAccessOk"
                [disabled]="shouldDisableRsActionsUntilAccessOk"
                [attr.title]="shouldDisableRsActionsUntilAccessOk ? 'No Access yet' : null"
                (click)="setActiveTab('visualisation')"
                type="button"
              >
                <svg *ngIf="!isLoggedIn" class="dataset-detail--tab-lock-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Visualisation
              </button>
              <button
                class="dataset-detail--tab"
                [class.active]="activeTab === 'sql-playground'"
                [class.disabled]="shouldDisableRsActionsUntilAccessOk"
                [disabled]="shouldDisableRsActionsUntilAccessOk"
                [attr.title]="shouldDisableRsActionsUntilAccessOk ? 'No Access yet' : null"
                (click)="setActiveTab('sql-playground')"
                type="button"
              >
                <svg *ngIf="!isLoggedIn" class="dataset-detail--tab-lock-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                SQL Playground
              </button>
              <button
                class="dataset-detail--tab"
                [class.active]="activeTab === 'discussion'"
                (click)="setActiveTab('discussion')"
                type="button"
              >
                Discussion
              </button>
              -->
          </div>
          <!-- New Discussion Button - To the right of tabs -->
          <div class="dataset-detail--tabs-actions" *ngIf="activeTab === 'discussion'">
            <button 
              class="dataset-detail--new-discussion-btn"
              type="button"
              (click)="createNewDiscussion()"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 5V19M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              New Discussion
            </button>
          </div>
        </div>

        <!-- Warning Message for Pending Publish Status -->
        <div class="dataset-detail--pending-warning" *ngIf="isPublishStatusPending">
          <div class="dataset-detail--pending-warning-content">
            <svg class="dataset-detail--pending-warning-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <div class="dataset-detail--pending-warning-text">
              <strong>Your dataset or model is under review.</strong> Will be available for other users to view the dataset post Approval from the Organisation administrator / Platform Administrator.
            </div>
          </div>
        </div>

        <!-- Info Message for Declined/Rejected Publish Status -->
        <div class="dataset-detail--declined-info" *ngIf="isPublishStatusDeclined">
          <div class="dataset-detail--declined-info-content">
            <svg class="dataset-detail--declined-info-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <div class="dataset-detail--declined-info-text">
              Your request to approve the Dataset is being Rejected. Please try creating a new one and get the approval from the Org Admin.
            </div>
          </div>
        </div>

        <!-- Under Review Message (dataUploadStatus key absent — data upload/processing not yet complete) -->
        <div class="dataset-detail--pending-warning" *ngIf="isDataUploadStatusAbsent && !isPublishStatusPending && !isPublishStatusDeclined">
          <div class="dataset-detail--pending-warning-content">
            <svg class="dataset-detail--pending-warning-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <div class="dataset-detail--pending-warning-text">
              <strong>This dataset is under review.</strong> Action buttons will be available once the data upload and processing is complete.
            </div>
          </div>
        </div>

        <div class="dataset-detail--row" [class.full-width]="activeTab === 'discussion' || activeTab === 'details' || activeTab === 'visualisation' || activeTab === 'sql-playground'">
          <!-- Left Column: Tags, Description and Attributes -->
          <div class="dataset-detail--col-left" [class.full-width]="activeTab === 'discussion' || activeTab === 'details' || activeTab === 'visualisation' || activeTab === 'sql-playground'">
            <!-- Tab Content: Dataset -->
            <div class="dataset-detail--tab-content" *ngIf="activeTab === 'dataset'">
              <!-- Tags -->
              <div class="dataset-detail--tags-header" *ngIf="datasetTags.length > 0">
              <span 
                *ngFor="let tag of visibleTags" 
                class="dataset-detail--tag-header"
                [title]="tag"
              >
                {{ tag }}
              </span>
              <span 
                *ngIf="remainingTagsCount > 0"
                class="dataset-detail--more-link-header"
                (click)="openTagsModal()"
              >
                +{{ remainingTagsCount }} More
              </span>
            </div>
            
            <!-- Description -->
            <p class="dataset-detail--description" *ngIf="datasetDescription">{{ datasetDescription }}</p>
            
            <!-- Dataset Attributes -->
            <div class="dataset-detail--attributes-section" *ngIf="hasDatasetDetails">
              <div class="dataset-detail--attribute-item" *ngIf="datasetDetails.uploadedBy">
                <svg class="dataset-detail--attribute-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <div class="dataset-detail--attribute-content">
                  <div class="dataset-detail--attribute-label">Uploaded by:</div>
                  <div class="dataset-detail--attribute-value">{{ datasetDetails.uploadedBy }}</div>
                </div>
              </div>
              
              <div class="dataset-detail--attribute-item" *ngIf="datasetDetails.organisationType">
                <svg class="dataset-detail--attribute-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <div class="dataset-detail--attribute-content">
                  <div class="dataset-detail--attribute-label">Organisation type:</div>
                  <div class="dataset-detail--attribute-value">{{ datasetDetails.organisationType }}</div>
                </div>
              </div>
              
              <!--
              <div class="dataset-detail--attribute-item" *ngIf="datasetDetails.industry">
                <svg class="dataset-detail--attribute-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <polyline points="9 22 9 12 15 12 15 22" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <div class="dataset-detail--attribute-content">
                  <div class="dataset-detail--attribute-label">Industry:</div>
                  <div class="dataset-detail--attribute-value">{{ datasetDetails.industry }}</div>
                </div>
              </div>
              -->
              
              <div class="dataset-detail--attribute-item" *ngIf="datasetDetails.organizationName">
                <svg class="dataset-detail--attribute-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <div class="dataset-detail--attribute-content">
                  <div class="dataset-detail--attribute-label">Organization Name:</div>
                  <div class="dataset-detail--attribute-value">{{ datasetDetails.organizationName }}</div>
                </div>
              </div>
              
              <div class="dataset-detail--attribute-item" *ngIf="datasetDetails.yearRange">
                <svg class="dataset-detail--attribute-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <div class="dataset-detail--attribute-content">
                  <div class="dataset-detail--attribute-label">Year range:</div>
                  <div class="dataset-detail--attribute-value">{{ datasetDetails.yearRange }}</div>
                </div>
              </div>
              
              <div class="dataset-detail--attribute-item" *ngIf="datasetDetails.license">
                <svg class="dataset-detail--attribute-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <div class="dataset-detail--attribute-content">
                  <div class="dataset-detail--attribute-label">License:</div>
                  <div class="dataset-detail--attribute-value">{{ datasetDetails.license }}</div>
                </div>
              </div>
            </div>

            <!--
            Resource Server Details hidden for now
            <div class="dataset-detail--resource-servers" *ngIf="resourceServersList.length > 0">
              <div class="dataset-detail--resource-servers-header">
                <h4 class="dataset-detail--resource-servers-heading">Resource Server Details</h4>
                <button
                  *ngIf="showTryOutButton"
                  type="button"
                  class="dataset-detail--try-out-btn"
                  (click)="openTryOutModal()"
                >
                  API Explorer
                </button>
              </div>

              <div class="dataset-detail--resource-server-list" *ngIf="resourceServerDesign === 'cards'">
                <div class="dataset-detail--resource-server-card" *ngFor="let rs of resourceServersList">
                  <div class="dataset-detail--resource-server-card-header">
                    <svg class="dataset-detail--resource-server-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <rect x="2" y="2" width="20" height="8" rx="2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <rect x="2" y="14" width="20" height="8" rx="2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M6 6h.01M6 18h.01M18 6h.01M18 18h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                    <span class="dataset-detail--resource-server-card-name">{{ rs.name || '—' }}</span>
                  </div>
                  <div class="dataset-detail--resource-server-card-body" *ngIf="rs.url || (rs.queryTypes && rs.queryTypes.length)">
                    <div class="dataset-detail--resource-server-single-row">
                      <span class="dataset-detail--resource-server-meta" *ngIf="rs.url">
                        <span class="dataset-detail--resource-server-value dataset-detail--resource-server-url">{{ rs.url }}</span>
                      </span>
                      <span class="dataset-detail--resource-server-meta" *ngIf="rs.queryTypes && rs.queryTypes.length">
                        <span class="dataset-detail--resource-server-value">
                          <span class="dataset-detail--resource-server-tag" *ngFor="let qt of rs.queryTypes">{{ qt }}</span>
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="dataset-detail--resource-server-table-wrap" *ngIf="resourceServerDesign === 'table'">
                <table class="dataset-detail--resource-server-table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>URL</th>
                      <th>Query types</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let rs of resourceServersList">
                      <td class="dataset-detail--rs-table-name">{{ rs.name || '—' }}</td>
                      <td class="dataset-detail--rs-table-url">{{ rs.url || '—' }}</td>
                      <td class="dataset-detail--rs-table-types">
                        <span class="dataset-detail--resource-server-tag" *ngFor="let qt of rs.queryTypes">{{ qt }}</span>
                        <span *ngIf="!rs.queryTypes || !rs.queryTypes.length">—</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="dataset-detail--resource-server-attr-list" *ngIf="resourceServerDesign === 'list'">
                <div class="dataset-detail--resource-server-attr-item" *ngFor="let rs of resourceServersList">
                  <svg class="dataset-detail--attribute-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <rect x="2" y="2" width="20" height="8" rx="2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <rect x="2" y="14" width="20" height="8" rx="2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M6 6h.01M6 18h.01M18 6h.01M18 18h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                  <div class="dataset-detail--resource-server-attr-content">
                    <div class="dataset-detail--resource-server-attr-label">{{ rs.name || '—' }}</div>
                    <div class="dataset-detail--resource-server-attr-value">
                      <span *ngIf="rs.url" class="dataset-detail--resource-server-url-inline">{{ rs.url }}</span>
                      <span *ngIf="rs.url && rs.queryTypes?.length" class="dataset-detail--resource-server-sep"> · </span>
                      <span class="dataset-detail--resource-server-tag" *ngFor="let qt of rs.queryTypes">{{ qt }}</span>
                      <span *ngIf="!rs.url && (!rs.queryTypes || !rs.queryTypes.length)">—</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            -->
            </div>

            <!-- Tab Content: Details (Version Files + Data Bank Viewer Preview) - always visible -->
            <div class="dataset-detail--tab-content" *ngIf="activeTab === 'details'">
              <div class="details-tab--layout">
                <!-- Left Column: Version Files Card -->
                <div class="details-tab--left-panel">
                  <div class="details-tab--version-files-card">
                    <div class="details-tab--card-title-row">
                      <h4 class="details-tab--card-title">Version Files</h4>
                    </div>
                    
                    <!-- File Tree Search -->
                    <div class="details-tab--file-tree-search" *ngIf="versionFiles.length > 0">
                      <input
                        type="text"
                        class="details-tab--file-tree-search-input"
                        placeholder="Search files or folders"
                        [(ngModel)]="versionFileSearchTerm"
                        (ngModelChange)="onVersionFileSearchChange()"
                      />
                    </div>

                    <!-- File Tree -->
                    <div class="details-tab--file-list" *ngIf="hasVisibleVersionFileNodes">
                      <div
                        *ngFor="let entry of visibleVersionFileNodes"
                        class="details-tab--file-item"
                        [class.details-tab--file-item-folder]="entry.node.type === 'folder'"
                        [class.selected]="entry.node.type === 'file' && selectedVersionFileName === entry.node.path"
                        [style.padding-left.px]="16 + (entry.depth * 16)"
                        (click)="onVersionFileNodeClick(entry.node)"
                      >
                        <button
                          *ngIf="entry.node.type === 'folder'"
                          type="button"
                          class="details-tab--folder-toggle"
                          (click)="toggleVersionFolder(entry.node.path); $event.stopPropagation()"
                          [attr.aria-label]="isVersionFolderExpanded(entry.node.path) ? 'Collapse folder' : 'Expand folder'"
                        >
                          <svg
                            class="details-tab--folder-toggle-icon"
                            [class.details-tab--folder-toggle-icon-expanded]="isVersionFolderExpanded(entry.node.path)"
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <polyline points="9 18 15 12 9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </button>
                        <span *ngIf="entry.node.type !== 'folder'" class="details-tab--folder-toggle-placeholder"></span>
                        <svg *ngIf="entry.node.type === 'folder'" class="details-tab--file-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                          <path d="M3 7a2 2 0 0 1 2-2h5l2 2h7a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <svg *ngIf="entry.node.type === 'file'" class="details-tab--file-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                          <path d="M13 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V9L13 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M13 2V9H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <span class="details-tab--file-name">{{ entry.node.name }}</span>
                        <span *ngIf="entry.node.type === 'folder' && entry.node.isLoading" class="details-tab--folder-loading">
                          Loading...
                        </span>
                      </div>
                    </div>
                    <div class="details-tab--file-list-hint" *ngIf="visibleVersionFileNodeLimitReached">
                      Showing first {{ maxVisibleVersionFileNodes }} items. Refine search to narrow results.
                    </div>
                    
                    <!-- No Files Message -->
                    <div class="details-tab--no-files" *ngIf="!detailsTabDataLoading && versionFiles.length === 0">
                      <p class="details-tab--no-files-text">No files</p>
                    </div>
                    <div class="details-tab--no-files" *ngIf="!detailsTabDataLoading && versionFiles.length > 0 && !hasVisibleVersionFileNodes">
                      <p class="details-tab--no-files-text">No matching files or folders</p>
                    </div>
                    
                    <!-- File stats removed as per requirements -->
                  </div>
                </div>
                
                <!-- Right Column: Dataset Preview -->
                <div class="details-tab--right-panel">
                  <div class="details-tab--viewer-preview">
                    <h4 class="details-tab--viewer-title">
                      Dataset Preview for
                      <span *ngIf="selectedVersionFileName" class="details-tab--viewer-file">
                        {{ selectedVersionFileName }}
                      </span>
                    </h4>
                    
                    <!-- Metadata information for selected file (directly under title) -->
                    <div
                      class="details-tab--viewer-metadata"
                      *ngIf="!detailsTabDataLoading && selectedVersionFileName"
                    >
                      <div class="details-tab--viewer-metadata-row" *ngIf="selectedFileSizeDisplay">
                        <span class="details-tab--viewer-metadata-label">File size</span>
                        <span class="details-tab--viewer-metadata-value">{{ selectedFileSizeDisplay }}</span>
                      </div>
                      <div class="details-tab--viewer-metadata-row" *ngIf="selectedFileLastUpdatedDisplay">
                        <span class="details-tab--viewer-metadata-label">Last updated</span>
                        <span class="details-tab--viewer-metadata-value">{{ selectedFileLastUpdatedDisplay }}</span>
                      </div>
                      <div class="details-tab--viewer-metadata-row" *ngIf="datasetDetails.license">
                        <span class="details-tab--viewer-metadata-label">License</span>
                        <span class="details-tab--viewer-metadata-value">{{ datasetDetails.license }}</span>
                      </div>
                    </div>

                    <!-- Loading State (file list loading or preview loading on file click) -->
                    <div class="details-tab--loading" *ngIf="detailsTabDataLoading || detailsPreviewLoading">
                      <div class="details-tab--loading-spinner"></div>
                      <p>{{ detailsPreviewLoading ? 'Loading preview...' : 'Loading data...' }}</p>
                    </div>
                    
                    <!-- Visual separator between file stats and preview table -->
                    <div class="details-tab--viewer-separator"></div>
                    
                    <!-- Data Table (Preview) -->
                    <div class="details-tab--table-wrapper" *ngIf="!detailsTabDataLoading && !detailsPreviewLoading && detailsPreviewEntries.length > 0">
                      <div class="details-tab--table-container">
                        <table class="details-tab--table">
                          <thead>
                            <tr>
                              <th *ngFor="let header of detailsPreviewHeaders">{{ header }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let entry of detailsPreviewEntries.slice(0, 10)">
                              <td *ngFor="let header of detailsPreviewHeaders">
                                {{ getDetailsTableValue(entry, header) }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    
                    <!-- Empty State (Preview) -->
                    <div class="details-tab--empty-state" *ngIf="!detailsTabDataLoading && !detailsPreviewLoading && detailsPreviewEntries.length === 0">
                      <p>Click a file to view preview</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Tab Content: Visualisation -->
            <div class="dataset-detail--tab-content" *ngIf="activeTab === 'visualisation'">
              <app-dataset-visualisation
                [datasetId]="datasetId"
                [versionFiles]="versionFiles"
                [versionFilesTotalSize]="versionFilesTotalSize"
                [versionFilesLastUpdated]="versionFilesLastUpdated"
                [license]="datasetDetails.license || ''"
              ></app-dataset-visualisation>
            </div>

            <!-- Tab Content: SQL Playground -->
            <div class="dataset-detail--tab-content" *ngIf="activeTab === 'sql-playground'">
              <app-sql-playground
                [datasetId]="datasetId"
                [versionFiles]="versionFiles"
                [versionFilesTotalSize]="versionFilesTotalSize"
                [versionFilesLastUpdated]="versionFilesLastUpdated"
                [license]="datasetDetails.license || ''"
              ></app-sql-playground>
            </div>

            <!-- Tab Content: Discussion -->
            <div class="dataset-detail--tab-content" *ngIf="activeTab === 'discussion'">
              <!-- Loading State -->
              <div class="dataset-detail--discussion-loading" *ngIf="datasetDiscussionsLoading">
                <p>Loading discussions...</p>
              </div>
              <!-- Error State -->
              <div class="dataset-detail--discussion-error" *ngIf="!datasetDiscussionsLoading && datasetDiscussionsError">
                <p>{{ datasetDiscussionsError }}</p>
              </div>
              <!-- Discussion List (shared design for dataset & model) -->
              <div class="dataset-detail--discussion-list" *ngIf="!datasetDiscussionsLoading && !datasetDiscussionsError && datasetDiscussions.length > 0">
                <app-asset-discussion-list
                  [discussions]="datasetDiscussions"
                  assetTypeLabel="Dataset"
                  (navigate)="navigateToDiscussion($event)"
                ></app-asset-discussion-list>
              </div>

              <!-- Empty State -->
              <div class="dataset-detail--discussion-empty" *ngIf="!datasetDiscussionsLoading && !datasetDiscussionsError && datasetDiscussions.length === 0">
                <p>No discussions yet. Be the first to start a discussion about this dataset.</p>
              </div>
            </div>
          </div>

          <!-- Right Column: Dataset Details and Actions -->
          <div class="dataset-detail--col-right" *ngIf="activeTab === 'dataset'">
            <!-- Activity Overview Card -->
            <div class="dataset-detail--activity-overview">
              <div class="activity-overview--header">
                <h3 class="activity-overview--title">Activity Overview</h3>
              </div>
              <div class="activity-overview--metrics">
                <!-- Like -->
                <div class="activity-overview--metric">
                  <svg class="activity-overview--metric-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <span class="activity-overview--metric-value">{{ activityMetrics.likes | number }}</span>
                </div>
                <!-- View -->
                <div class="activity-overview--metric">
                  <svg class="activity-overview--metric-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 12S5 4 12 4S23 12 23 12S19 20 12 20S1 12 1 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2"/>
                  </svg>
                  <span class="activity-overview--metric-value">{{ activityMetrics.views | number }}</span>
                </div>
              </div>
            </div>

            <div class="dataset-detail--right-section">
              <!-- Header with Title and Request Access Button -->
              <div class="dataset-detail--right-header">
                <h3 class="dataset-detail--right-title">Dataset Details</h3>
                
                <!-- Action buttons hidden when dataUploadStatus is absent (under review) -->
                <ng-container *ngIf="!isDataUploadStatusAbsent">
                <!-- Request Access Button (for Restricted access, when user doesn't have access) -->
                <button 
                  *ngIf="shouldShowRequestAccessButton && !isPublishStatusPending" 
                  class="dataset-detail--request-access-btn dataset-detail--request-access-btn--header" 
                  [disabled]="isRequestAccessButtonDisabled"
                  (click)="onRequestAccess()"
                >
                  {{ requestAccessButtonText }}
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <polyline points="9 18 15 12 9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
                
                <!-- Github Repo Button (if mediaURL exists) -->
                <button 
                  *ngIf="isOpenAccess && hasMediaURL" 
                  class="dataset-detail--github-repo-btn dataset-detail--github-repo-btn--header" 
                  (click)="onGithubRepoClick()"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" fill="currentColor" stroke="none"/>
                  </svg>
                  Github Repo
                </button>
                </ng-container>
              </div>
              
              <!-- Dataset Details List -->
              <div class="dataset-detail--details-list">
                <!-- Permission Badge - Aligned with detail items -->
                <div class="dataset-detail--detail-item dataset-detail--permission-item" *ngIf="datasetCardDetails.badge">
                  <svg class="dataset-detail--detail-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <div class="dataset-detail--detail-content">
                    <div class="dataset-detail--detail-label">Permission:</div>
                    <div class="dataset-detail--detail-value">
                      <span class="dataset-detail--permission-badge">
                        <svg class="dataset-detail--permission-badge-icon" width="14" height="14" viewBox="0 0 24 24" fill="none">
                          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M12 2v20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <circle cx="12" cy="12" r="2" fill="currentColor"/>
                        </svg>
                        <span>{{ datasetCardDetails.badge }}</span>
                      </span>
                    </div>
                  </div>
                </div>
                
                <!-- Data Readiness -->
                <div class="dataset-detail--detail-item" *ngIf="datasetCardDetails.dataReadiness && datasetCardDetails.dataReadiness !== 'NA'">
                  <svg class="dataset-detail--detail-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M9 11l3 3L22 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <div class="dataset-detail--detail-content">
                    <div class="dataset-detail--detail-label">Data Readiness:</div>
                    <div class="dataset-detail--detail-value dataset-detail--readiness-value">
                      <!-- Circular Progress Bar (stroke-dasharray bound so fill matches percentage) -->
                      <div class="readiness-progress">
                        <svg class="readiness-progress-circle" width="24" height="24" viewBox="0 0 36 36">
                          <circle class="readiness-progress-bg" cx="18" cy="18" r="15.915" fill="none" stroke="#e5e7eb" stroke-width="3"/>
                          <circle class="readiness-progress-bar" cx="18" cy="18" r="15.915" fill="none" stroke="#00a86b" stroke-width="3" 
                            stroke-linecap="round" 
                            [attr.stroke-dasharray]="readinessProgressDashArray"
                            transform="rotate(-90 18 18)"/>
                        </svg>
                      </div>
                      <!-- Score Value -->
                      <span class="readiness-score">{{ datasetCardDetails.dataReadiness }}%</span>
                      <!-- PDF Icon -->
                      <svg class="readiness-pdf-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" (click)="openDataReadinessPdf()">
                        <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="#00a86b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
                        <path d="M14 2V8H20" stroke="#00a86b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
                        <path d="M10 13H14M10 17H14" stroke="#00a86b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </div>
                  </div>
                </div>
                
                <div class="dataset-detail--detail-item" *ngIf="datasetCardDetails.fileFormat">
                  <svg class="dataset-detail--detail-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M13 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V9L13 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M13 2V9H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <div class="dataset-detail--detail-content">
                    <div class="dataset-detail--detail-label">File format:</div>
                    <div class="dataset-detail--detail-value">{{ datasetCardDetails.fileFormat }}</div>
                  </div>
                </div>
                
                <div class="dataset-detail--detail-item" *ngIf="datasetCardDetails.uploadFrequency">
                  <svg class="dataset-detail--detail-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <polyline points="17 8 12 3 7 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <line x1="12" y1="3" x2="12" y2="15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <div class="dataset-detail--detail-content">
                    <div class="dataset-detail--detail-label">Upload frequency:</div>
                    <div class="dataset-detail--detail-value">
                      <ng-container *ngIf="datasetCardDetails.uploadFrequency">
                        <ng-container *ngIf="isDateTimeFormat(datasetCardDetails.uploadFrequency); else textValue">
                          {{ getDatePart(datasetCardDetails.uploadFrequency) }}
                          <span class="dataset-detail--detail-time" *ngIf="getTimePart(datasetCardDetails.uploadFrequency)">
                            {{ getTimePart(datasetCardDetails.uploadFrequency) }}
                          </span>
                        </ng-container>
                        <ng-template #textValue>
                          {{ datasetCardDetails.uploadFrequency }}
                        </ng-template>
                      </ng-container>
                    </div>
                  </div>
                </div>
                
                <div class="dataset-detail--detail-item" *ngIf="datasetCardDetails.verifiedBy">
                  <svg class="dataset-detail--detail-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M9 12l2 2 4-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <div class="dataset-detail--detail-content">
                    <div class="dataset-detail--detail-label">Verified by:</div>
                    <div class="dataset-detail--detail-value dataset-detail--detail-value-truncate" [title]="datasetCardDetails.verifiedBy">{{ datasetCardDetails.verifiedBy }}</div>
                  </div>
                </div>
                
                <div class="dataset-detail--detail-item" *ngIf="datasetCardDetails.createdAt">
                  <svg class="dataset-detail--detail-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <div class="dataset-detail--detail-content">
                    <div class="dataset-detail--detail-label">Created at:</div>
                    <div class="dataset-detail--detail-value">
                      <ng-container *ngIf="datasetCardDetails.createdAt">
                        {{ getCreatedAtDate(datasetCardDetails.createdAt) }}
                        <span class="dataset-detail--detail-time" *ngIf="getCreatedAtTime(datasetCardDetails.createdAt)">
                          {{ getCreatedAtTime(datasetCardDetails.createdAt) }}
                        </span>
                      </ng-container>
                    </div>
                  </div>
                </div>
                
                <div class="dataset-detail--detail-item" *ngIf="datasetCardDetails.updatedAt">
                  <svg class="dataset-detail--detail-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <div class="dataset-detail--detail-content">
                    <div class="dataset-detail--detail-label">Updated at:</div>
                    <div class="dataset-detail--detail-value">
                      <ng-container *ngIf="datasetCardDetails.updatedAt">
                        {{ getCreatedAtDate(datasetCardDetails.updatedAt) }}
                        <span class="dataset-detail--detail-time" *ngIf="getCreatedAtTime(datasetCardDetails.updatedAt)">
                          {{ getCreatedAtTime(datasetCardDetails.updatedAt) }}
                        </span>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- Divider -->
              <hr class="dataset-detail--action-divider" />
              
              <!-- Action Buttons - hidden when dataUploadStatus is absent (under review) -->
              <div class="dataset-detail--action-buttons" *ngIf="!isDataUploadStatusAbsent">
                <!-- When FILE: only View File button (disabled until has_access returns 200 OK) -->
                <button 
                  *ngIf="shouldShowViewFile" 
                  class="dataset-detail--action-btn" 
                  [disabled]="shouldDisableRsActionsUntilAccessOk"
                  (click)="onViewFile()"
                >
                  <div class="dataset-detail--action-icon-wrapper">
                    <svg class="dataset-detail--action-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M13 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V9L13 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M13 2V9H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                  <span>View File</span>
                </button>

                <!-- Sample Data: show when item API has dataSample (intuitive JSON in modal) -->
                <button *ngIf="hasDataSample" class="dataset-detail--action-btn dataset-detail--action-btn-sample" (click)="onCardAction('sample-data')">
                  <div class="dataset-detail--action-icon-wrapper">
                    <svg class="dataset-detail--action-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                  <span>Sample Data</span>
                </button>
                
                <button *ngIf="hasDataDescriptor" class="dataset-detail--action-btn" (click)="onCardAction('data-descriptors')">
                  <div class="dataset-detail--action-icon-wrapper">
                    <svg class="dataset-detail--action-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M13 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V9L13 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M13 2V9H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <line x1="8" y1="13" x2="16" y2="13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                      <line x1="8" y1="17" x2="16" y2="17" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                  </div>
                  <span>Data Descriptors</span>
                </button>
                
                <button 
                  *ngIf="!shouldShowViewFile && canShowQueryData" 
                  class="dataset-detail--action-btn" 
                  [disabled]="shouldDisableRsActionsUntilAccessOk"
                  (click)="onCardAction('query-data')"
                >
                  <div class="dataset-detail--action-icon-wrapper">
                    <svg class="dataset-detail--action-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <ellipse cx="12" cy="5" rx="9" ry="3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                  <span>Query data</span>
                </button>
                
                <button *ngIf="!shouldShowViewFile" class="dataset-detail--action-btn" (click)="onCardAction('view-code')">
                  <div class="dataset-detail--action-icon-wrapper">
                    <svg class="dataset-detail--action-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <polyline points="16 18 22 12 16 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <polyline points="8 6 2 12 8 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                  <span>View code</span>
                </button>
                
                <!-- Get Data Button (when ATTR in resourceServer or iudxResourceAPIs; disabled until has_access returns 200 OK) -->
                <button 
                  *ngIf="shouldShowGetDataButton" 
                  class="dataset-detail--action-btn" 
                  [disabled]="shouldDisableRsActionsUntilAccessOk"
                  (click)="onGetData()"
                >
                  <div class="dataset-detail--action-icon-wrapper">
                    <svg class="dataset-detail--action-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <polyline points="7 10 12 15 17 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <line x1="12" y1="15" x2="12" y2="3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                  </div>
                  <span>Get Data</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Similar Datasets Section -->
    <div class="dataset-detail--similar-section">
      <div class="dataset-detail--container">
        <app-similar-datasets 
          [datasets]="similarDatasets"
          [title]="'Similar Datasets'"
          [itemsToShow]="3"
          [showDots]="similarDatasets.length > 3"
          [showArrows]="similarDatasets.length > 3"
          [gap]="24"
        ></app-similar-datasets>
      </div>
    </div>
  </div>

  <app-footer></app-footer>

  <!-- Create Discussion Offcanvas -->
  <app-create-discussion-offcanvas
    [(visible)]="showCreateDiscussionOffcanvas"
    [initialValues]="discussionInitialValues"
    (publish)="onDiscussionPublish($event)"
    (close)="onDiscussionClose()"
  ></app-create-discussion-offcanvas>

  <!-- Tags Modal -->
  <app-modal
    [(visible)]="showTagsModal"
    header="All Tags"
    [width]="'600px'"
    [showFooter]="false"
    (visibleChange)="showTagsModal = $event"
  >
    <div class="tags-modal-content">
      <div class="tags-modal--tags">
        <span 
          *ngFor="let tag of allTags" 
          class="dataset-detail--tag"
        >
          {{ tag }}
        </span>
      </div>
    </div>
  </app-modal>

  <!-- Sample Data Modal (dataSample from item API – intuitive JSON) -->
  <app-modal
    [(visible)]="showSampleDataModal"
    header="Sample Data"
    [width]="'900px'"
    [showFooter]="false"
    (visibleChange)="showSampleDataModal = $event"
  >
    <div class="sample-data-modal-content">
      <div class="sample-data-modal--data-wrapper">
        <div class="sample-data-modal--data">
          <div class="sample-data-modal--inner-toolbar" *ngIf="hasDataSample">
            <span class="sample-data-modal--format-badge">JSON</span>
            <button class="sample-data-modal--icon-btn sample-data-modal--icon-btn-copy" (click)="copySampleData()" title="Copy to clipboard">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <rect x="9" y="9" width="13" height="13" rx="2" ry="2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <button class="sample-data-modal--icon-btn sample-data-modal--icon-btn-download" (click)="downloadSampleData()" title="Download as file">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <polyline points="7 10 12 15 17 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <line x1="12" y1="15" x2="12" y2="3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </button>
          </div>
          <pre class="sample-data-modal--json" *ngIf="formattedSampleData">{{ formattedSampleData }}</pre>
          <p class="sample-data-modal--empty" *ngIf="!formattedSampleData">No sample data available.</p>
        </div>
      </div>
    </div>
  </app-modal>

  <!-- Data Descriptors Modal (dataDescriptor from item API) -->
  <app-modal
    [(visible)]="showDataDescriptorsModal"
    header="Data Descriptors"
    [width]="'900px'"
    [showFooter]="false"
    (visibleChange)="showDataDescriptorsModal = $event"
  >
    <div class="data-descriptors-modal-content">
      <div class="data-descriptors-modal--layout">
        <!-- Left: Attribute list (label from API) -->
        <div class="data-descriptors-modal--left-panel">
          <div class="data-descriptors-modal--label">Attributes</div>
          <div class="data-descriptors-modal--list">
            <div
              *ngFor="let element of dataDescriptors; let last = last"
              class="data-descriptors-modal--list-item"
              [class.selected]="selectedDataElement === element.name"
              (click)="selectDataElement(element.name)"
            >
              <div class="data-descriptors-modal--list-item-content">
                <span class="data-descriptors-modal--list-item-name" [title]="element.name">{{ element.label || element.name }}</span>
                <svg
                  *ngIf="selectedDataElement === element.name"
                  class="data-descriptors-modal--list-item-arrow"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <polyline points="9 18 15 12 9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="data-descriptors-modal--list-item-divider" *ngIf="!last"></div>
            </div>
          </div>
        </div>

        <!-- Right: Selected attribute details (dataSchema, description, type, sample value) -->
        <div class="data-descriptors-modal--right-panel">
          <ng-container *ngIf="selectedDescriptor; else noDescriptor">
            <div class="data-descriptors-modal--detail-card">
              <div class="data-descriptors-modal--detail-row">
                <span class="data-descriptors-modal--detail-label">Label</span>
                <span class="data-descriptors-modal--detail-value">{{ selectedDescriptor.label || selectedDescriptor.name }}</span>
              </div>
              <div class="data-descriptors-modal--detail-row">
                <span class="data-descriptors-modal--detail-label">Description</span>
                <span class="data-descriptors-modal--detail-value">{{ selectedDescriptor.description }}</span>
              </div>
              <div class="data-descriptors-modal--detail-row" *ngIf="selectedDescriptorSampleValue !== undefined && selectedDescriptorSampleValue !== null">
                <span class="data-descriptors-modal--detail-label">Sample Value</span>
                <span class="data-descriptors-modal--detail-value data-descriptors-modal--sample-value">{{ selectedDescriptorSampleValue }}</span>
              </div>
            </div>
          </ng-container>
          <ng-template #noDescriptor>
            <p class="data-descriptors-modal--empty-hint">Select an attribute to view details.</p>
          </ng-template>
        </div>
      </div>
    </div>
  </app-modal>

  <!-- View Code Modal -->
  <app-modal
    [(visible)]="showViewCodeModal"
    header="View Code"
    [width]="'900px'"
    [showFooter]="false"
    (visibleChange)="showViewCodeModal = $event"
  >
    <div class="view-code-modal-content">
      <!-- Header Section with Tabs -->
      <div class="view-code-modal--header">
        <!-- Tabs -->
        <div class="view-code-modal--tabs-wrapper">
          <div class="view-code-modal--tabs" *ngIf="viewCodeTabs.length > 1">
            <button
              *ngFor="let tab of viewCodeTabs"
              class="view-code-modal--tab"
              [class.active]="viewCodeActiveTab === tab.name"
              (click)="setViewCodeTab(tab.name)"
              type="button"
            >
              {{ tab.name }}
            </button>
          </div>
          <div class="view-code-modal--tab-label" *ngIf="viewCodeTabs.length === 1">
            <span class="view-code-modal--tab-label-text">{{ viewCodeTabs[0]?.name || 'Code' }}</span>
          </div>
        </div>
      </div>

      <!-- Code Display Area -->
      <div class="view-code-modal--code-wrapper">
        <div class="view-code-modal--code-header">
          <span class="view-code-modal--code-language">Python</span>
          <span class="view-code-modal--code-info">{{ getCurrentViewCode().split('\n').length }} lines</span>
        </div>
        <div class="view-code-modal--code">
          <div class="view-code-modal--code-inner-toolbar">
            <button class="view-code-modal--btn view-code-modal--btn-copy" (click)="copyCode()" title="Copy code to clipboard">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <rect x="9" y="9" width="13" height="13" rx="2" ry="2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <button class="view-code-modal--btn view-code-modal--btn-download" (click)="downloadCode()" title="Download code as file">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <polyline points="7 10 12 15 17 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <line x1="12" y1="15" x2="12" y2="3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </button>
          </div>
          <pre class="view-code-modal--code-content"><code>{{ getCurrentViewCode() }}</code></pre>
        </div>
      </div>
    </div>
  </app-modal>

  <!-- Query Data Modal: Date Range Filter -->
  <app-modal
    [(visible)]="showQueryDataModal"
    header="Query Data"
    [width]="'800px'"
    [showFooter]="false"
    (visibleChange)="onQueryDataModalVisibleChange($event)"
  >
    <div class="query-data-modal-content query-data-modal--date-range">
      <div class="query-data-modal--leaf-pattern">
        <img src="/assets-leaf.png" alt="" class="query-data-modal--leaf-image" />
      </div>
      <p class="query-data-modal--intro">Select a date range to fetch temporal data from this dataset.</p>
      <div class="query-data-modal--loading" *ngIf="queryDataLoading">
        <div class="query-data-modal--loading-spinner"></div>
        <p>Loading temporal data...</p>
      </div>
      <ng-container *ngIf="!queryDataLoading">
        <div class="query-data-modal--date-range-row">
          <div class="query-data-modal--field query-data-modal--date-range-field">
            <label class="query-data-modal--field-label" for="query-data-range">Date Range</label>
            <app-date-range-picker
              id="query-data-range"
              [ngModel]="queryDataDateRange"
              (ngModelChange)="onQueryDataDateRangeChange($event)"
              placeholder="Choose Date Range"
              styleClass="query-data-modal--date-picker"
              [attr.aria-describedby]="queryDataDateError ? 'query-data-error' : null"
            ></app-date-range-picker>
            <p class="query-data-modal--error" id="query-data-error" *ngIf="queryDataDateError" role="alert">{{ queryDataDateError }}</p>
          </div>
          <div class="query-data-modal--actions query-data-modal--date-actions">
            <button
              type="button"
              class="query-data-modal--reset-btn"
              (click)="onQueryDataReset()"
            >
              Reset
            </button>
            <button
              type="button"
              class="query-data-modal--submit-btn"
              [disabled]="!isQueryDataFormValid"
              (click)="onQueryDataSearch()"
            >
              Search
            </button>
          </div>
        </div>
      </ng-container>

      <!-- Response section: always visible, content toggles based on API state -->
      <div class="query-data-modal--response-section">
        <div class="query-data-modal--response-json">
          <div class="query-data-modal--response-toolbar" *ngIf="queryDataResponse">
            <button
              type="button"
              class="query-data-modal--download-btn"
              (click)="downloadQueryDataJson()"
              title="Download JSON"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <polyline points="7 10 12 15 17 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <line x1="12" y1="15" x2="12" y2="3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </button>
          </div>
          <pre class="query-data-modal--response-json-content">
{{ queryDataLoading
  ? 'Loading temporal data...'
  : (queryDataResponse
      ? getQueryDataResponseFormatted()
      : 'Run a search to view temporal data for this dataset.') }}</pre>
        </div>
      </div>
    </div>
  </app-modal>

  <!-- Request Access Modal (Additional Information for Download Request) -->
  <app-modal
    [(visible)]="showRequestAccessModal"
    header="Additional Information for Download Request"
    [width]="'700px'"
    [showFooter]="false"
    (visibleChange)="showRequestAccessModal = $event"
  >
    <div class="request-access-modal-content">
      <div class="request-access-modal--leaf-pattern">
        <img src="/assets-leaf.png" alt="" class="request-access-modal--leaf-image" />
      </div>
      <div class="request-access-modal--body">
      <!-- User has no organisation: show Individual / Organisation choice -->
      <ng-container *ngIf="!userHasOrganisation">
        <div class="request-access-modal--field request-access-modal--field-first">
          <label class="request-access-modal--label">Request as</label>
          <div class="request-access-modal--radio-group request-access-modal--radio-group-cards">
            <label
              class="request-access-modal--radio-card"
              [class.request-access-modal--radio-card-selected]="queryDataForm.requestAs === 'Individual'"
            >
              <input
                type="radio"
                name="requestAs"
                value="Individual"
                [(ngModel)]="queryDataForm.requestAs"
                class="request-access-modal--radio-input"
              />
              <span class="request-access-modal--radio-dot"></span>
              <span class="request-access-modal--radio-card-label">Individual</span>
            </label>
            <label
              class="request-access-modal--radio-card"
              [class.request-access-modal--radio-card-selected]="queryDataForm.requestAs === 'Organisation'"
            >
              <input
                type="radio"
                name="requestAs"
                value="Organisation"
                [(ngModel)]="queryDataForm.requestAs"
                class="request-access-modal--radio-input"
              />
              <span class="request-access-modal--radio-dot"></span>
              <span class="request-access-modal--radio-card-label">Organisation</span>
            </label>
          </div>
        </div>
        <div class="request-access-modal--field request-access-modal--join-org-cta" *ngIf="queryDataForm.requestAs === 'Organisation'">
          <div class="request-access-modal--join-org-box">
            <p class="request-access-modal--join-org-text">You need to join or create an organisation to request access as an organisation.</p>
            <button
              type="button"
              class="request-access-modal--join-org-link"
              (click)="goToJoinOrganisation()"
            >
              Join or Create an Organisation
            </button>
          </div>
        </div>
        <ng-container *ngIf="queryDataForm.requestAs === 'Individual'">
          <div class="request-access-modal--field">
            <label class="request-access-modal--label">
              Purpose
              <span class="request-access-modal--required">*</span>
            </label>
            <div class="request-access-modal--textarea-wrapper">
              <textarea
                class="request-access-modal--textarea"
                [(ngModel)]="queryDataForm.purposeDescription"
                placeholder="Please briefly describe how you plan to use this asset"
                rows="4"
                maxlength="200"
              ></textarea>
              <span class="request-access-modal--char-count">{{ purposeDescriptionLength }}/200 character limit</span>
            </div>
          </div>
          <div class="request-access-modal--field request-access-modal--checkbox-row">
            <input
              type="checkbox"
              id="request-access-agree"
              [(ngModel)]="queryDataForm.agreeToTerms"
              class="request-access-modal--checkbox"
            />
            <label for="request-access-agree" class="request-access-modal--checkbox-label">I have read the <a
              href="/documents/Data%20Usage%20Agreement.pdf"
              download="Data Usage Agreement.pdf"
              class="request-access-modal--link"
              (click)="$event.stopPropagation()"
            >Data Usage Agreement</a> and agree with Terms of Service and Privacy Policy of NHA</label>
          </div>
          <div class="request-access-modal--actions">
            <button
              type="button"
              class="request-access-modal--cancel-btn"
              (click)="closeRequestAccessModal()"
            >
              Cancel
            </button>
            <button
              type="button"
              class="request-access-modal--submit-btn"
              [disabled]="!isFormValid"
              (click)="submitRequestAccess()"
            >
              Request Access
            </button>
          </div>
        </ng-container>
      </ng-container>

      <!-- User has organisation: show only Organisation Name (disabled) + Purpose + checkbox + buttons -->
      <ng-container *ngIf="userHasOrganisation">
        <div class="request-access-modal--field request-access-modal--field-first">
          <label class="request-access-modal--label">
            Organisation Name
            <span
              class="request-access-modal--info-icon"
              title="Your organisation from your profile"
            >i</span>
          </label>
          <input
            type="text"
            class="request-access-modal--input"
            [(ngModel)]="queryDataForm.organisationName"
            [readonly]="true"
            placeholder="Enter organisation name"
          />
        </div>
        <div class="request-access-modal--field">
          <label class="request-access-modal--label">
            Purpose
            <span class="request-access-modal--required">*</span>
          </label>
          <div class="request-access-modal--textarea-wrapper">
            <textarea
              class="request-access-modal--textarea"
              [(ngModel)]="queryDataForm.purposeDescription"
              placeholder="Please briefly describe how you plan to use this asset"
              rows="4"
              maxlength="200"
            ></textarea>
            <span class="request-access-modal--char-count">{{ purposeDescriptionLength }}/200 character limit</span>
          </div>
        </div>
        <div class="request-access-modal--field request-access-modal--checkbox-row">
          <input
            type="checkbox"
            id="request-access-agree-org"
            [(ngModel)]="queryDataForm.agreeToTerms"
            class="request-access-modal--checkbox"
          />
          <label for="request-access-agree-org" class="request-access-modal--checkbox-label">I have read the <a
            href="/documents/Data%20Usage%20Agreement.pdf"
            download="Data Usage Agreement.pdf"
            class="request-access-modal--link"
            (click)="$event.stopPropagation()"
          >Data Usage Agreement</a> and agree with Terms of Service and Privacy Policy of NHA</label>
        </div>
        <div class="request-access-modal--actions">
          <button
            type="button"
            class="request-access-modal--cancel-btn"
            (click)="closeRequestAccessModal()"
          >
            Cancel
          </button>
          <button
            type="button"
            class="request-access-modal--submit-btn"
            [disabled]="!isFormValid"
            (click)="submitRequestAccess()"
          >
            Request Access
          </button>
        </div>
      </ng-container>
      </div>
    </div>
  </app-modal>

  <!-- View File Modal (PDF / DOCX viewer) -->
  <app-modal
    [(visible)]="showViewFileModal"
    header="View File"
    [width]="'90vw'"
    [showFooter]="false"
    (visibleChange)="onViewFileModalVisibleChange($event)"
  >
    <div class="view-file-modal-content">
      <!-- Tabs when both PDF and DOCX -->
      <div class="view-file-modal--tabs" *ngIf="hasViewFileMultipleTypes">
        <button
          type="button"
          class="view-file-modal--tab"
          [class.active]="viewFileActiveTab === 'pdf'"
          (click)="onViewFileTabChange('pdf')"
        >
          PDF
        </button>
        <button
          type="button"
          class="view-file-modal--tab"
          [class.active]="viewFileActiveTab === 'docx'"
          (click)="onViewFileTabChange('docx')"
        >
          DOCX
        </button>
      </div>
      <!-- Loading -->
      <div class="view-file-modal--loading" *ngIf="viewFileLoading">
        <div class="view-file-modal--loading-spinner"></div>
        <p>Loading file...</p>
      </div>
      <!-- PDF viewer -->
      <div class="view-file-modal--viewer" *ngIf="!viewFileLoading && viewFileActiveTab === 'pdf'">
        <iframe
          *ngIf="viewFilePdfSafeUrl"
          class="view-file-modal--iframe"
          [src]="viewFilePdfSafeUrl"
          title="PDF viewer"
        ></iframe>
        <div class="view-file-modal--no-file" *ngIf="!viewFilePdfSafeUrl && !viewFileLoading">
          No PDF file to display.
        </div>
      </div>
      <!-- DOCX: download link (in-browser DOCX preview would require mammoth package) -->
      <div class="view-file-modal--viewer view-file-modal--docx" *ngIf="!viewFileLoading && viewFileActiveTab === 'docx'">
        <div class="view-file-modal--docx-download" *ngIf="viewFileDocxSafeDownloadUrl">
          <p class="view-file-modal--docx-download-text">DOCX preview is not available in the browser. Download the file to view it.</p>
          <a
            class="view-file-modal--docx-download-btn"
            [href]="viewFileDocxSafeDownloadUrl"
            [attr.download]="viewFileDocxFileName"
          >
            Download {{ viewFileDocxFileName }}
          </a>
        </div>
        <div class="view-file-modal--no-file" *ngIf="!viewFileDocxSafeDownloadUrl && !viewFileLoading">
          No document to display.
        </div>
      </div>
    </div>
  </app-modal>

  <!-- Login Modal -->
  <app-login-modal *ngIf="showLoginModal" (visibleChange)="showLoginModal = false"></app-login-modal>

  <!-- Get Data - Gateway / OGC STAC modal (uses model-popup wrapper) -->
  <app-model-popup
    [isOpen]="isFeatureDataOpen && featureDataMode.type !== 'OGC_FEATURE'"
    [title]="''"
    [config]="{ closeOnOverlayClick: false, showCloseButton: false, showHeader: false }"
    (closeModal)="onCloseFeatureData()"
  >
    @if (featureDataMode.type === 'GATEWAY' || featureDataMode.type === 'DEFAULT') {
      <app-gateway-data
        [resourceItemData]="featureDataResourceItem"
        [dataModel]="featureDataMode.dataModel ?? 'model1'"
        (closeRequested)="onCloseFeatureData()"
      />
    } @else if (featureDataMode.type === 'OGC_STAC') {
      <app-ogc-stac-data
        [resourceItemData]="stacResourceItem"
        (closeRequested)="onCloseFeatureData()"
      />
    }
  </app-model-popup>

  <!-- Get Data - OGC Feature map (self-contained overlay) -->
  @if (isFeatureDataOpen && featureDataMode.type === 'OGC_FEATURE') {
    <app-ogc-feature-data
      [resourceItemData]="featureDataResourceItem"
      (closeRequested)="onCloseFeatureData()"
    />
  }

  <!-- Get Data Modal (FILE mode only: PDF viewer or download) -->
  <app-modal
    [(visible)]="showGetDataModal"
    header="Get Data"
    [width]="getDataMode === 'file' ? '90vw' : '1000px'"
    [showFooter]="false"
    (visibleChange)="onGetDataModalVisibleChange($event); showGetDataModal = $event"
  >
    <div class="get-data-modal-content">
      <!-- Loading State -->
      <div class="get-data-modal--loading" *ngIf="getDataLoading">
        <div class="get-data-modal--loading-spinner"></div>
        <p>Loading data...</p>
      </div>

      <!-- FILE mode: PDF viewer or download link -->
      <div class="get-data-modal--file-wrapper" *ngIf="!getDataLoading && getDataMode === 'file'">
        <div class="get-data-modal--pdf-viewer" *ngIf="getDataPdfSafeUrl">
          <iframe
            class="get-data-modal--pdf-iframe"
            [src]="getDataPdfSafeUrl"
            title="PDF viewer"
          ></iframe>
        </div>
        <div class="get-data-modal--file-download" *ngIf="getDataFileDownloadSafeUrl && !getDataPdfSafeUrl">
          <p class="get-data-modal--file-download-text">This file cannot be previewed in the browser. Download to view.</p>
          <a
            class="get-data-modal--file-download-btn"
            [href]="getDataFileDownloadSafeUrl"
            [attr.download]="getDataFileName"
          >
            Download {{ getDataFileName }}
          </a>
        </div>
        <div class="get-data-modal--empty-state" *ngIf="!getDataPdfSafeUrl && !getDataFileDownloadSafeUrl">
          <p class="get-data-modal--empty-text">No file available to display.</p>
        </div>
      </div>

      <!-- Entity mode: Data Display - Table View -->
      <div class="get-data-modal--data-wrapper" *ngIf="!getDataLoading && getDataMode === 'entity'">
        <!-- Data Content - Table View -->
        <div class="get-data-modal--data-content" *ngIf="getDataEntries.length > 0">
          <div class="get-data-modal--table-container">
            <table class="get-data-modal--table">
              <thead>
                <tr>
                  <th *ngFor="let header of getTableHeaders()" class="get-data-modal--table-header">
                    {{ header }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let entry of getDataEntries" class="get-data-modal--table-row">
                  <td *ngFor="let header of getTableHeaders()" class="get-data-modal--table-cell">
                    <span 
                      class="get-data-modal--cell-content"
                      [title]="getTableValue(entry, header)"
                    >{{ getTableValue(entry, header) }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Empty State -->
        <div class="get-data-modal--empty-state" *ngIf="getDataEntries.length === 0">
          <svg class="get-data-modal--empty-icon" width="64" height="64" viewBox="0 0 24 24" fill="none">
            <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M14 2V8H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <p class="get-data-modal--empty-text">No data available</p>
        </div>

        <!-- Pagination and Actions -->
        <div class="get-data-modal--footer" *ngIf="getDataEntries.length > 0">
          <!-- Entry Count -->
          <div class="get-data-modal--entry-count" *ngIf="getDataTotalEntries > 0">
            Showing {{ getGetDataStartEntry() }} - {{ getGetDataEndEntry() }} of {{ getDataTotalEntries }} entries
          </div>

          <!-- Pagination -->
          <div class="get-data-modal--pagination">
            <button 
              class="get-data-modal--pagination-btn"
              [disabled]="getDataCurrentPage === 1 || getDataLoading"
              (click)="onGetDataPageChange(getDataCurrentPage - 1)"
              type="button"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <polyline points="15 18 9 12 15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            
            <div class="get-data-modal--pagination-numbers">
              <button
                *ngFor="let pageNum of getGetDataPageNumbers()"
                class="get-data-modal--pagination-number"
                [class.active]="pageNum === getDataCurrentPage"
                (click)="onGetDataPageChange(pageNum)"
                type="button"
              >
                {{ pageNum }}
              </button>
            </div>
            
            <button 
              class="get-data-modal--pagination-btn"
              [disabled]="getDataCurrentPage === getDataTotalPages || getDataLoading"
              (click)="onGetDataPageChange(getDataCurrentPage + 1)"
              type="button"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <polyline points="9 18 15 12 9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>

          <!-- Download CSV Button -->
          <button
            class="get-data-modal--download-btn"
            (click)="downloadGetDataCSV()"
            [disabled]="getDataLoading"
            type="button"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <polyline points="7 10 12 15 17 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <line x1="12" y1="15" x2="12" y2="3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
            Download CSV
          </button>
        </div>
      </div>
    </div>
  </app-modal>
</div>

<!-- Data Readiness PDF Viewer Modal -->
<app-modal
  [(visible)]="showDataReadinessPdfModal"
  [width]="'90vw'"
  header=""
  [showFooter]="false"
  (onClose)="closeDataReadinessPdfModal()"
>
  <div class="pdf-viewer-container">
    <div *ngIf="!dataReadinessPdfUrl" class="pdf-loading">
      Loading PDF...
    </div>
    <pdf-viewer
      *ngIf="dataReadinessPdfUrl"
      [src]="dataReadinessPdfUrl"
      [render-text]="true"
      [original-size]="false"
      [show-all]="true"
      [zoom]="1"
      [autoresize]="true"
      style="display: block; width: 100%; height: 80vh;"
    ></pdf-viewer>
  </div>
</app-modal>

  <app-modal
    [(visible)]="showTryOutModal"
    header="API Explorer"
    [headerTemplate]="tryOutModalHeader"
    [width]="'96vw'"
    [styleClass]="'custom-modal try-out-dialog'"
    [showFooter]="false"
    (visibleChange)="onTryOutModalVisibleChange($event)"
  >
    <ng-template #tryOutModalHeader>
      <div class="try-out-custom__modal-header">
        <div class="try-out-custom__modal-header-title">API Explorer</div>
        <div class="try-out-custom__modal-header-controls" *ngIf="tryOutSpec">
          <label class="try-out-custom__label try-out-custom__label--inline try-out-custom__modal-header-label">Server:</label>
          <div class="try-out-custom__modal-header-select">
            <select class="try-out-custom__server-select" [(ngModel)]="selectedTryOutServerUrl">
              <option *ngFor="let server of tryOutSpec.servers || []" [value]="server.url">
                {{ server.url }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </ng-template>

    <div class="try-out-modal">
      <div *ngIf="tryOutYamlLoading" class="try-out-modal--loading try-out-modal--overlay">
        <div class="try-out-modal--loading-spinner"></div>
        <p>Loading API documentation...</p>
      </div>

      <div *ngIf="tryOutYamlError" class="try-out-modal--error">
        {{ tryOutYamlError }}
      </div>

      <div *ngIf="!tryOutYamlError && tryOutSpec" class="try-out-custom">
        <div class="try-out-custom__layout">
          <div class="try-out-custom__operations-panel">
            <div class="try-out-custom__operations">
              <div
                class="try-out-custom__card"
                [class.try-out-custom__card--active]="isTryOutOperationExpanded(operation.id)"
                *ngFor="let operation of tryOutOperations"
              >
                <button type="button" class="try-out-custom__summary" (click)="toggleTryOutOperation(operation.id)">
                  <div class="try-out-custom__summary-main">
                    <span
                      class="try-out-custom__summary-icon checkbox-checkmark-custom"
                      [class.checked]="isTryOutOperationExpanded(operation.id)"
                      aria-hidden="true"
                    ></span>
                    <div class="try-out-custom__summary-copy">
                      <span class="try-out-custom__summary-title">{{ operation.summary || operation.path }}</span>
                    </div>
                    <span [class]="getTryOutMethodClass(operation.method)">{{ operation.method }}</span>
                  </div>
                </button>
              </div>
            </div>
          </div>

          <aside class="try-out-custom__response-panel">
            <div *ngIf="activeTryOutOperation as activeOperation; else tryOutOperationPlaceholder" class="try-out-custom__response-card">
              <div class="try-out-custom__workspace-header">
                <div>
                  <h3 class="try-out-custom__response-title">
                    {{ activeOperation.summary || activeOperation.path || 'Operation Details' }}
                  </h3>
                  <div class="try-out-custom__path try-out-custom__path--detail">{{ activeOperation.path }}</div>
                </div>
                <span [class]="getTryOutMethodClass(activeOperation.method)">
                  {{ activeOperation.method }}
                </span>
              </div>

              <p *ngIf="activeOperation.description" class="try-out-custom__description try-out-custom__description--workspace">{{ activeOperation.description }}</p>

              <div *ngIf="activeOperation.parameters.length" class="try-out-custom__section try-out-custom__section--surface">
                <h3 class="try-out-custom__section-title">Parameters</h3>
                <div class="try-out-custom__param-grid">
                  <div class="try-out-custom__param" *ngFor="let param of activeOperation.parameters">
                    <label class="try-out-custom__label">
                      {{ param.name }}
                      <span class="try-out-custom__param-meta">({{ param.in }})</span>
                    </label>
                    <input
                      class="try-out-custom__input"
                      [value]="tryOutRequestState[activeOperation.id]?.params?.[param.name] || ''"
                      (input)="setTryOutParamValue(activeOperation.id, param.name, $any($event.target).value)"
                      [placeholder]="param.example || ('Enter ' + param.name)"
                    />
                  </div>
                </div>
              </div>

              <div *ngIf="activeOperation.requestContentType" class="try-out-custom__section try-out-custom__section--surface">
                <h3 class="try-out-custom__section-title">Request Body</h3>
                <div class="try-out-custom__content-type">{{ activeOperation.requestContentType }}</div>
                <textarea
                  class="try-out-custom__textarea"
                  [value]="tryOutRequestState[activeOperation.id]?.bodyText || ''"
                  (input)="setTryOutRequestBody(activeOperation.id, $any($event.target).value)"
                  rows="10"
                ></textarea>
              </div>

              <div class="try-out-custom__actions try-out-custom__actions--workspace">
                <button type="button" class="try-out-custom__action try-out-custom__action--primary" (click)="executeCustomTryOut(activeOperation)">
                  Execute
                </button>
                <button type="button" class="try-out-custom__action try-out-custom__action--secondary" (click)="resetTryOutOperation(activeOperation)">
                  Reset
                </button>
              </div>

              <div *ngIf="activeTryOutExecutionResult?.curl" class="try-out-custom__section try-out-custom__section--surface">
                <h3 class="try-out-custom__section-title">cURL</h3>
                <pre class="try-out-custom__code">{{ activeTryOutExecutionResult?.curl }}</pre>
              </div>

              <div class="try-out-custom__section try-out-custom__section--surface">
                <h3 class="try-out-custom__section-title">Response</h3>
                <div *ngIf="activeTryOutExecutionResult?.loading" class="try-out-custom__response-state">
                  Executing request...
                </div>
                <div *ngIf="!activeTryOutExecutionResult?.loading && activeTryOutExecutionResult?.status" class="try-out-custom__response-status">
                  Status: {{ activeTryOutExecutionResult?.status }} {{ activeTryOutExecutionResult?.statusText }}
                </div>
                <div *ngIf="activeTryOutExecutionResult?.error" class="try-out-custom__response-error">
                  {{ activeTryOutExecutionResult?.error }}
                </div>
                <div *ngIf="!activeTryOutExecutionResult?.loading && !activeTryOutExecutionResult?.status && !activeTryOutExecutionResult?.error" class="try-out-custom__response-placeholder">
                  Execute the selected operation to view the response here.
                </div>
                <pre *ngIf="activeTryOutExecutionResult?.body" class="try-out-custom__code">{{ activeTryOutExecutionResult?.body }}</pre>
              </div>
            </div>

            <ng-template #tryOutOperationPlaceholder>
              <div class="try-out-custom__response-card">
                <div class="try-out-custom__response-placeholder">
                  Select an operation from the left to view its request details.
                </div>
              </div>
            </ng-template>
          </aside>
        </div>
      </div>
    </div>
  </app-modal>